import { CategoryDto } from "../category/category.dto";

export class TaskTypeDto extends CategoryDto {
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/task-type/task-type.dto.ts